import { createContext, useContext, useEffect, useState, useCallback } from "react";
import ar from "@/locales/ar.json";
import en from "@/locales/en.json";

const DICTS = { ar, en };
const I18nCtx = createContext(null);

const lookup = (dict, key) => key.split(".").reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), dict);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("onex_lang") || "ar");
  useEffect(() => {
    localStorage.setItem("onex_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);
  const t = useCallback((key, params) => {
    let s = lookup(DICTS[lang], key) ?? lookup(DICTS.ar, key) ?? key;
    if (typeof s === "string" && params) Object.entries(params).forEach(([k, v]) => { s = s.replaceAll(`{${k}}`, v); });
    return s;
  }, [lang]);
  const pick = useCallback((obj) => (obj ? obj[lang] || obj.ar || obj.en || "" : ""), [lang]);
  const money = useCallback((halalas) => {
    const v = (Number(halalas || 0) / 100).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return lang === "ar" ? `${v} ر.س` : `SAR ${v}`;
  }, [lang]);
  const date = useCallback((iso) => (iso ? new Date(iso).toLocaleDateString(lang === "ar" ? "ar-SA-u-ca-gregory-nu-latn" : "en-GB", { year: "numeric", month: "short", day: "numeric" }) : "—"), [lang]);
  return <I18nCtx.Provider value={{ lang, setLang, t, pick, money, date, dir: lang === "ar" ? "rtl" : "ltr" }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
